<template>
  <div :class="$style.sectionTitle">
    <div class="">
      <p class="sub-title">{{ subTitle }}</p>
      <h2 class="title" v-html="title"> </h2>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    subTitle: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" module>
$color-primary: #d8b37f;

.sectionTitle {
  :global {
    .sub-title {
      color: $color-primary;
      text-align: center;
      font-size: 16px;
    }

    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 24px;
      margin-bottom: 2rem;
      text-align: center;
      line-height: 1.7;

      &::after {
        content: '';
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: $color-primary;
        margin-left: 8px;
      }

      &::before {
        content: '';
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: $color-primary;
        margin-right: 8px;
      }
    }
  }
}

@media (min-width: 768px) {
  .sectionTitle {
    :global {
      .sub-title {
        font-size: 22px;
      }
      .title {
        font-size: 40px;
      }
    }
  }
}
</style>
